import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern, password_validation } from '../../../shared/constants';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-doctor-form',
	templateUrl: './doctor-form.component.html',
	styleUrl: './doctor-form.component.css'
})
export class DoctorFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	roleList: any = [{ 'id': "Doctor", 'role': 'Doctor' }, { 'id': "Psychologist", 'role': 'Psychologist' }, { 'id': "Staff", 'role': 'Staff' }, { 'id': "Wellness", 'role': 'Wellness' }];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			f_name: ['', [Validators.required]],
			l_name: ['', [Validators.required]],
			password: ['', [Validators.required, password_validation]],
			role: [this.roleList[1].id, [Validators.required]],
			qualification: [''],
			key_id: [''],
			email: [null, [Validators.required, Validators.pattern(emailPattern)]],
			enable2fa: [false]
		});
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		if (this.uId) {
			this.f.password.clearValidators();
			this.f.password.setValidators(null);
			this.f.password.updateValueAndValidity();
			this.getDetails();
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getDoctorDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.f.f_name.setValue(data.f_name);
				this.f.l_name.setValue(data.l_name);
				this.f.role.setValue(data.role);
				this.f.qualification.setValue(data.qualification);
				this.f.email.setValue(data.email);
				this.f.key_id.setValue(data.key_id);
				this.f.enable2fa.setValue(data.enable2fa);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	fileToUpload!: File;

	onFileSelect(event: any) {
		if (event.target.files.length > 0) {
			const file = event.target.files[0];
			this.fileToUpload = file;
		}
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}

		/* let payload = {
			"role":this.f.role.value,
			"f_name":this.f.f_name.value,
			"l_name":this.f.l_name.value,
			"email":this.f.email.value,
			"key_id":this.f.key_id.value,
			"stamp":this.fileToUpload,
			"qualification":this.f.qualification.value,
			"unique_id":null,
			"id":this.uId,
			"password":this.f.password.value,
			"enable2fa":this.f.enable2fa.value,
		} */
		const payload = new FormData();
		if (this.fileToUpload) {
			payload.append('stamp', this.fileToUpload);
		}
		payload.append('f_name', this.f.f_name.value);
		payload.append('email', this.f.email.value);
		payload.append('l_name', this.f.l_name.value);
		payload.append('role', this.f.role.value);
		payload.append('id', this.uId);
		payload.append('password', this.f.password.value);
		/* payload.append('unique_id', null); */
		payload.append('qualification', this.f.qualification.value);
		payload.append('enable2fa', this.f.enable2fa.value);
		if (this.f.key_id.value) {
			payload.append('key_id', this.f.key_id.value);
		}
		this.showLoader = true;

		this.apiService.createDoctor(payload).subscribe((data: any) => {
			this.showLoader = false;
			this.toastr.success("Doctor saved successfully", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			this.created.emit();
		}, (error) => {
			this.showLoader = false;
			if (error.status == 401) { return }
			if (error.status == 409) {
				Swal.fire({
					title: 'Already Exists',
					html: 'User with name <strong>' + this.f.f_name.value + " " + this.f.l_name.value + '</strong> already exists. Do you want to restore it?',
					icon: 'question',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonText: 'Yes, Restore!',
					cancelButtonText: 'Cancel',
					confirmButtonColor: '#3e4fb1'
				}).then((result) => {
					if (result.value) {
						this.apiService.restoreDoctor(error.error.id).subscribe((data: any) => {
							this.toastr.success("User restored successfully", 'Success', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							this.created.emit();
						}, (error) => {
							this.toastr.error("Something went wrong", 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						});
					} else if (result.dismiss === Swal.DismissReason.cancel) { }
				})
			} else {
				let errorMsg: any = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						this.toastr.error(errorMsg.Error ? errorMsg.Error : errorMsg.info, 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						return;
					} else {
						if (errorMsg == "Username not available") { errorMsg = 'Email id is already used.'; }
						this.toastr.error(errorMsg, 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						return;
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
